import { CommonModule, Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../core/services/alert/alert.service';
import { ClientsService } from '../../../core/services/clients/clients.service';
import { FormAddOrderComponent } from '../../orders/form-add-order/form-add-order.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DataService } from '../../../core/services/orders/data.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { Title } from '@angular/platform-browser';
import { AccountsService } from '../../../core/services/accounts/accounts.service';
import { UsersService } from '../../../core/services/users/users.service';
import { BrandService } from '../../../core/services/brand/brand.service';
import { DocumentsTypeService } from '../../../core/services/documentType/documents-type.service';
import { BadgeColorPipe } from '../../../core/pipe/badge-color.pipe';
import { BadgeVehiclePipe } from '../../../core/pipe/badge-vehicle.pipe';
import { BadgeClientPipe } from '../../../core/pipe/badge-client.pipe';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';

interface AccountData {
  reference: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any; // ajusta según la estructura real de root_account si es necesario
  status: boolean;
}
interface ApiResponse {
  data: AccountData[];
  // Otros campos posibles como error, message, etc.
}

@Component({
  selector: 'app-form-clients-orders',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    BadgeColorPipe,
    BadgeVehiclePipe,
    BadgeClientPipe,
  ],
  templateUrl: './form-clients-orders.component.html',
  styleUrl: './form-clients-orders.component.css',
})
export class FormClientsOrdersComponent {
  @Input() client_reference: any;
  @Input() document_buttons_chico = false;
  @Input() client?: any;
  @Input() activeFormTab?: any;
  @Input() clientData?: any;
  @Input() orderData?: any;
  ladata: any = [];

  order_reference?: any;
  showForm = false;
  typeOrders: string = 'drafts';
  title = 'orders';

  @Output() emitOpenOrderForm = new EventEmitter<boolean>();
  @Output() emitOpenOrderForm2 = new EventEmitter<boolean>();

  sortColumn = 'stage_updated_at';
  sortDirection = 'asc';

  expandedRow: any = null;
  accountType: string | null = null;

  showAddOrderForm = false;

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'broker_reference',
    'supplier',
    'vendor',
    'vehicle',
    'updated_at',
    'stage',
    'actions',
  ];
  constructor(
    private router: Router,
    private alertService: AlertService,
    private clientsService: ClientsService,
    private dataService: DataService,
    private orderService: OrdersService,
    private titleService: Title,
    private translate: TranslateService,
    private accountService: AccountsService,
    private userService: UsersService,
    private brandService: BrandService,
    private documentTypeService: DocumentsTypeService,
    private authStateService: AuthStateService
  ) {
    this.accountType = this.authStateService.getAccountType();
  }

  sortMap: { [key: string]: string } = {

    updated_at: 'updated_at',

  };
  ngOnInit(): void {
    this.fetchAllData();
    this.sortColumn = this.sortMap['updated_at'];
    this.sortDirection = 'desc';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ladata']) {
      this.getClientsOrders(this.client_reference);
    }
  }

  getLaData(): void {
    this.dataService.getLadata;
  }

  getClientsOrders(reference: string): void {
    if (reference) {
      this.alertService.loading('swal_messages.please_wait');
      this.clientsService.getClientsOrders(reference).subscribe({
        next: (data) => {
          let aux: any = data.data;
          aux.sort((a: any, b: any) => {
            const dateA = a.updated_at ? new Date(a.updated_at).getTime() : 0;
            const dateB = b.updated_at ? new Date(b.updated_at).getTime() : 0;
            return dateB - dateA; // ascendente (menor a mayor)
          });
          this.dataSource.data = aux;
          this.alertService.close();
        },
        error: (err) => {
          console.error('Error al obtener las ordenes del cliente:', err);
        },
      });
    }
  }

  getOrder(reference: string, stage: string): void {
    this.alertService.loading('swal_messages.please_wait');

    let adjustedStage;
    if (stage === 'draft') {
      adjustedStage = 'drafts';
    } else if (
      stage === 'sent' ||
      stage === 'cancellation_requested' ||
      stage === 'contract_sent'
    ) {
      adjustedStage = 'contracts';
    } else {
      adjustedStage = 'contracts';
    }
    const nuevaURL = `/orders/${adjustedStage}/${reference}`;
    this.router.navigateByUrl(nuevaURL).then(() => {
      this.order_reference = reference;
      this.orderService.searchOrder(this.order_reference).subscribe({
        next: (data) => {
          this.orderData = data.data;
          let title = data.data.client?.name
            ? `${data.data.client.name} ${data.data.client.lastname || ''}`
            : data.data.broker.reference;
          this.titleService.setTitle(
            `${this.translate.instant(
              'titles-menu-pages.' + this.title
            )} ${title} - DBM`
          );

          // Muestra el formulario de la orden
          this.showForm = true;
          this.alertService.close();
        },
        error: () => {
          this.alertService.error('swal_messages.order_not_found');
        },
      });
    });
  }

  toggleAddOrderForm(): void {
    this.showAddOrderForm = !this.showAddOrderForm;
  }

  addOrdersComponent?: FormAddOrderComponent;

  openAddOrderForm() {
    this.document_buttons_chico = true;
    this.emitOpenOrderForm.emit();
  }

  openAddOrderForm2() {
    this.document_buttons_chico = true;
    this.emitOpenOrderForm2.emit(this.clientData.name);
    this.showAddOrderForm = true;
  }

  /**********ladata****** */

  cargaladata: any = [];
  pageNumber: number = 1;
  pageSize: number = 100;
  searchParams: any = {};

  private fetchAllData() {
    Promise.all([
      this.getClientsOrders(this.client_reference),
      this.fetchData2(),
      this.fetchData3(),
      this.fetchData4(),
      this.fetchData5(),
      this.fetchData6(),
      this.fetchData7(),
      this.fetchData8(),
    ]).then(() => {
      this.ladata = this.cargaladata;
      this.dataService.setLadata(this.ladata);
      setTimeout(() => {
        this.alertService.close();
      }, 500);
    });
  }

  fetchData2(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.accountService.getData().subscribe({
        next: (response: ApiResponse) => {
          if (!response || !response.data) {
            resolve();
            return;
          }
          const data: AccountData[] = response.data;
          this.cargaladata.vendorData = data.filter(
            (item) => item.type === 'vendor'
          );
          this.cargaladata.brokerData = data.filter(
            (item) => item.type === 'broker'
          );
          this.cargaladata.supplierData = data.filter(
            (item) => item.type === 'supplier'
          );
          this.cargaladata.workshopData = data.filter(
            (item) => item.type === 'workshop'
          );
          this.cargaladata.dealershipData = data.filter(
            (item) => item.type === 'dealership'
          );
          resolve();
        },
        error: (error) => {
          reject(error); // Rechaza la promesa en caso de error
        },
      });
    });
  }
  fetchData3(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.brandService.getData().subscribe({
        next: (data) => {
          this.cargaladata.brands = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData4(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.documentTypeService.getSelectType().subscribe({
        next: (data) => {
          this.cargaladata.selectTypes = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData5(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.userService.getUserAgent().subscribe({
        next: (data) => {
          this.cargaladata.agentData = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData6(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.clientsService.getData().subscribe({
        next: (data) => {
          const updatedResponse = data.data.map((client: any) => {
            return {
              ...client,
              fullname: `${client.name}${client.lastname ? ` ${client.lastname}` : ''
                }`.trim(),
            };
          });
          this.cargaladata.clientData = updatedResponse;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  fetchData7(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderService.getStages().subscribe({
        next: (data) => {
          this.cargaladata.stages = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
  fetchData8(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderService.getDeliveryData().subscribe({
        next: (data) => {
          this.cargaladata.delivery_place = data.data.places;
          this.cargaladata.delivery_status = data.data.status;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }
}
